import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_INSTITUTIONCONTRACT_LOAD_BY_INSTITUTION_ID,
    ACTION_INSTITUTIONCONTRACT_LOAD_BY_ID,

    ACTION_INSTITUTIONCONTRACT_SAVE,

    ACTION_INSTITUTIONCONTRACT_CREATE,

    ACTION_INSTITUTIONCONTRACT_VALIDATE,

    IInstitutionContractLoadByInstitutionIdAction,
    IInstitutionContractLoadByIdAction,
    IInstitutionContractLoadFailureAction,
    IInstitutionContractLoadSuccessAction,

    IInstitutionContractSaveAction,
    IInstitutionContractSaveSuccessAction,
    IInstitutionContractSaveFailureAction,

    IInstitutionContractCreateAction,
    IInstitutionContractCreateSuccessAction,
    IInstitutionContractCreateFailureAction,

    IInstitutionContractValidateAction,
    IInstitutionContractValidateSuccessAction,
    IInstitutionContractValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/institutionContract";
import { institutionContractApi } from "../services/institutionContract";

export const
    getInstitutionContractByInstitutionIdEpic = (action$): Observable<IInstitutionContractLoadSuccessAction | IInstitutionContractLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONCONTRACT_LOAD_BY_INSTITUTION_ID)
            .mergeMap((action: IInstitutionContractLoadByInstitutionIdAction) => {
                return institutionContractApi
                    .getInstitutionContractByInstitutionId(action.institutionId)
                    .map(response =>
                        LoadSuccess(response.institutionContract, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getInstitutionContractByIdEpic = (action$): Observable<IInstitutionContractLoadSuccessAction | IInstitutionContractLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONCONTRACT_LOAD_BY_ID)
            .mergeMap((action: IInstitutionContractLoadByIdAction) => {
                return institutionContractApi
                    .getInstitutionContractById(action.id)
                    .map(response =>
                        LoadSuccess(response.institutionContract, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setInstitutionContractEpic = (action$): Observable<IInstitutionContractSaveSuccessAction | IInstitutionContractSaveFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONCONTRACT_SAVE)
            .mergeMap((action: IInstitutionContractSaveAction) => {
                return institutionContractApi
                    .setInstitutionContract(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.institutionContract, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createInstitutionContractEpic = (action$): Observable<IInstitutionContractCreateSuccessAction | IInstitutionContractCreateFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONCONTRACT_CREATE)
            .mergeMap((action: IInstitutionContractCreateAction) => {
                return institutionContractApi
                    .createInstitutionContract(action.institutionId)
                    .map(response =>
                        CreateSuccess(
                            response.institutionContract,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateInstitutionContractEpic = (action$): Observable<IInstitutionContractValidateSuccessAction | IInstitutionContractValidateFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONCONTRACT_VALIDATE)
            .mergeMap((action: IInstitutionContractValidateAction) => {
                return institutionContractApi
                    .validateInstitutionContract(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.institutionContract, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }